import { getUserAgent } from './getUserAgent'

// This is used to determine the TBrowser value
// If you need the results of this in code, use the value on
// window.deviceInfo, not this file
export const isSafari = () => {
  const ua = getUserAgent()
  const safariRegex = /^((?!chrome|android|chromium|edg).)*safari\//gim
  return safariRegex.test(ua)
}
